module.exports = __webpack_public_path__ + "media/images/help/image4-999ce3ed8aaff61d460afa1d809855ed.jpeg";